import store from   './store'
import request from './requests'

var Utilities = {

    checkIfNotEmptyUndefinedOrNull(val){
        if(val === '' || val == null || val == undefined) {
            return false;
        }else {
            return true;
        }
    },
    //
    // checkIfNotEmptyUndefinedOrNull2Values(val1, val2){
    //     return this.checkIfNotEmptyUndefinedOrNull(val1) &&  this.checkIfNotEmptyUndefinedOrNull(val2);
    // },
    //
    // checkIfNotEmptyUndefinedOrNull3Values(val1, val2, val3){
    //     return this.checkIfNotEmptyUndefinedOrNull(val1) &&  this.checkIfNotEmptyUndefinedOrNull(val2) &&  this.checkIfNotEmptyUndefinedOrNull(val3);
    // },
    //
    // checkIfNotEmptyUndefinedOrNull4Values(val1, val2, val3, val4){
    //     return this.checkIfNotEmptyUndefinedOrNull2Values(val1, val2) &&  this.checkIfNotEmptyUndefinedOrNull2Values(val3,val4);
    // },
    //
    // checkIfNotEmptyUndefinedOrNull5Values(val1, val2, val3, val4, val5){
    //     return this.checkIfNotEmptyUndefinedOrNull(val1)
    //         && this.checkIfNotEmptyUndefinedOrNull(val2)
    //         && this.checkIfNotEmptyUndefinedOrNull(val3)
    //         && this.checkIfNotEmptyUndefinedOrNull(val4)
    //         && this.checkIfNotEmptyUndefinedOrNull(val5);
    // },

    //set the token to localStorage
    setLocalStorage(storageName, data) {
        localStorage.setItem(storageName, JSON.stringify(data));
    },

    setRedirectToLocalStorage(data) {
        localStorage.setItem('redirectToken', JSON.stringify(data));
    },

    //get the token from localStorage
    getLocalStorage(storageName) {
        return JSON.parse(localStorage.getItem(storageName));
    },

    // delete the token from localStorage
    deleteLocalStorage(storageName) {
        localStorage.removeItem(storageName);
    },

    setSuccessPopup(text,fontStyleBig){
        var errorProps = {
            title: '',
            text: text,
            color: 'teal',
            class: 'white--text teal text-center justify-center',
            icon:'success',
            successStyle:true,
            fontStyleBig:fontStyleBig,
        };

        store.commit('setErrorPopup', true);
        store.commit('setErrorPopupProps', errorProps);
    },

    setErrorPopup(message){
        var errorProps = {
            title: 'Σφάλμα',
            text: message,
            color: 'error',
            class: 'white--text error text-center justify-center',
            icon:'error',
            successStyle:false,
            fontStyleBig:false
        };

        store.commit('setErrorPopup', true);
        store.commit('setErrorPopupProps', errorProps);
    },


    openErrorDialog(errorText) {
        var storeObj = {
            title: 'Σφάλμα!',
            text: errorText,
            color: 'error',
            class: 'white--text error text-center justify-center'
        };
        store.commit('setErrorPopup', true);
        store.commit('setErrorPopupProps', storeObj);
    },

    // create book path
    containsPathToBook(path) {
        if (path !== undefined && path.substring(0, 4) !== 'http') {
            return   'https://static.eudoxus.gr/books/' + path
        } else {
            return path
        }
    },

    //custom fix here cause the back-end function is used by other modules
    formatDatesCustom(date) {
        const [month, day, year] = date.split('/');
        return `${month}/${day}/${year}`; // it actually returns dd-MM-yyyy cause the back end sends Date to Json and that causes inconsistent behaviour
    },

    formatDate(date) {
        const [month, day, year] = date.split('/');
        return `${day}/${month}/${year}`;
    },

//    disabled Or Enabled Selected Buttons
    dissableOrEnableSelected(selectYear) {

        var distributionPointAllowedPeriod = store.getters.homePageInformation.distributionPointAllowedPeriod;
        var year = store.getters.editedYear;

        if (distributionPointAllowedPeriod) {
             if (year) {
                 if (selectYear.value == year) {
                     return true
                 }
             }
        }
        return false
    },

    //create current Date
    createPickerCurrentDate(){

        var currentDate = new Date();
        var formatDate = (("0" + (currentDate.getDate())).slice(-2))  + "-" + (("0" + (currentDate.getMonth() + 1)).slice(-2)) + "-" + currentDate.getFullYear();
        const [day, month, year] = formatDate.split('-');
        return `${year}-${month}-${day}`;
    },

//    check the history and enable participation modal
    checkpublisherHistory(homeInformation){

        if (homeInformation.eudoxusMembershipAllowedPeriod) {

            var years = store.getters.years;
            var currentYear;
            if (years.length > 0 ){
                currentYear = years[0].value
            }

            if (homeInformation.history != null && Object.keys(homeInformation.history).length > 0) {
                if (homeInformation.history[currentYear] != undefined){
                    if (homeInformation.history[currentYear].eudoxusMember == null) {
                        store.commit('setParticipationModal', true);
                        return
                    }
                }
                else {
                    store.commit('setParticipationModal', true);
                    return
                }
            }
            else {
                store.commit('setParticipationModal', true);
                return
            }
        }
        store.commit('setParticipationModal', false);
    },
    
    checkIfAllocator(homeInfoarmation){
        
        if (homeInfoarmation.type == 'Allocator') {
            var  navigationItems = [
                {id: 0, icon: 'home', label: 'Αρχική Σελίδα', link: '/', disabled: false},
                {id: 1, icon: 'book', label: 'Δωρεάν Ηλ.Βοηθήματα', link: '/books', disabled: false},
                {id: 2, icon: 'check_box', label: 'Επιλεγμένα Συγγράμματα', link: '/selectedBooks', disabled: false},
                ];
        }
        else {
            var  navigationItems = [
                {id: 0, icon: 'home', label: 'Αρχική Σελίδα', link: '/', disabled: false},
                {id: 1, icon: 'book', label: 'Συγγράμματα', link: '/books', disabled: false},
                {id: 2, icon: 'equalizer', label: 'Αναφορές', link: '/reports', disabled: false},
                {id: 3, icon: 'euro', label: 'Πληρωμές', link: '/payments', disabled: false},
                {id:4, icon:'description', label: 'Απόθεμα', link: '/stock', disabled: false},
                {id: 5, icon: 'local_shipping', label: 'Διανομή Courier', link: '/courier', disabled: false},
                {id: 6, icon: 'place', label: 'Σημεία Διανομής', link: '/distributionPoint', disabled: false},
                {id: 7, icon: 'check_box', label: 'Επιλεγμένα Συγγράμματα', link: '/selectedBooks', disabled: false},
                {id: 8, icon: 'assignment', label: 'Παραγγελίες Βιβλιοθηκών', link: '/libraryOrders', disabled: false},
            ];
        }

        store.commit('setNavigationItems', navigationItems);
    },

    downLoadPDFNewTab(response){
        let blob = new Blob([response.data], {
            type: "application/pdf"
        });


        let url = window.URL.createObjectURL(blob);
        window.open(url,"_blank")


        //window.URL.revokeObjectURL(url);
    },
    
    downLoadPDFNewTabWithFilename(response){
        let blob = new Blob([response.data], {
            type: "application/pdf"
        });
        
        const binaryString = atob(response.headers['filename']);
        
        // Convert binary string to UTF-8 text
        const decodedFileName = decodeURIComponent(escape(binaryString));
        
        let url = window.URL.createObjectURL(blob);
        
        window.open(url,"decodedErrorMessage")
        
        // Create a temporary anchor element
        let a = document.createElement('a');
        a.href = url;
        console.log(decodedFileName);
        a.download = decodedFileName;  // Set the correct filename here
        
        // Append to the body and trigger the download
        document.body.appendChild(a);
        a.click();
        
        // Clean up and revoke the object URL
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
    },

    downLoadPDF(response){

        let blob = new Blob([response.data], {
            type: "application/pdf"
        }); // 2. Get the blob setting file type in the response object returned by the request. Here is excel as an example.
        let url = window.URL.createObjectURL(blob); // 3. Create a temporary url pointing to the blob object

        // 4. After creating the url, you can simulate a series of operations on this file object, for example: preview, download
        let a = document.createElement("a");
        a.href = url;
        a.download = response.headers.filename;
        a.click();
        // 5. Release this temporary object url
        window.URL.revokeObjectURL(url);
    },

    downLoadXLSX(response){

        let blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"
        }); // 2. Get the blob setting file type in the response object returned by the request. Here is excel as an example.
        let url = window.URL.createObjectURL(blob); // 3. Create a temporary url pointing to the blob object

        // 4. After creating the url, you can simulate a series of operations on this file object, for example: preview, download
        let a = document.createElement("a");
        a.href = url;
        a.download = response.headers.filename;
        a.click();
        // 5. Release this temporary object url
        window.URL.revokeObjectURL(url);
    },

    downLoadXlsx(response) {

        const downloadUrl = window.URL.createObjectURL(new Blob([response]));

        const link = document.createElement('a');

        link.href = downloadUrl;

        link.setAttribute('download', 'file.zip'); //any other extension

        document.body.appendChild(link);

        link.click();

        link.remove();
    },

    downloadCsv(response, filename='file.csv') {
        const downloadUrl = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', filename); //any other extension

        document.body.appendChild(link);

        link.click();
        link.remove();
    },

    downloadXlsxFile(response, filename='file.xlsx') {
        const blob = new Blob([response], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.setAttribute('download', filename);

        document.body.appendChild(link);

        link.click();
        link.remove();
        window.URL.revokeObjectURL(downloadUrl);
    },


    returnDateFrom(dates) {

        if (dates.length > 0) {
            return dates[0];
        }
        return ''
    },

    returnDateTo(dates) {

        if (dates.length > 1) {
            return dates[1];
        }
        return ''
    },

    downloadReport(obj) {

        var token = this.getLocalStorage('token');
        if (token != null) {
            if (obj.format == 'pdf') {
                request.downloadReport(token, obj, this.downLoadPDF);
            }
            else {
                request.downloadReport(token, obj, this.downLoadXLSX);
            }
        }
        else {
            store.commit('setloginModal', true);
        }
    },

    sortDatesArray(dates){

        if (dates.length > 0) {
            if (dates.length == 2) {
                return dates.sort((a, b) => new Date(a) - new Date(b));
            }
        }
        return dates;
    }
}


export default Utilities
